import { render, staticRenderFns } from "./CafeSales.vue?vue&type=template&id=4e1a8038"
import script from "./CafeSales.vue?vue&type=script&lang=js"
export * from "./CafeSales.vue?vue&type=script&lang=js"
import style0 from "./CafeSales.vue?vue&type=style&index=0&id=4e1a8038&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports